import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createApiClient } from '@room/frontend-sdk';
import { registerDefaultTiles, setAuthAPI, applyThemeFromQuery } from '@room/shared-ui';
import { App } from './App';
import './index.css';
import '@room/shared-ui/styles/tokens.css';
import './styles/tailwind.css';
import '@room/shared-ui/styles/layout-tokens.css';
import '@room/shared-ui/styles/overflow-utilities.css';
import './styles/pages-fix.css';
import '@room/shared-ui/styles/general-list.css';
import '@room/shared-ui/styles/themes/messenger.css';
import '@room/shared-ui/styles/themes/debug.css';

applyThemeFromQuery();

registerDefaultTiles();

const api = createApiClient({
  baseURL: '/api',
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

setAuthAPI({
  getSession: () => api.get('/auth/session'),
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
